module.exports = __webpack_public_path__ + "static/media/bannerbg.fa70babc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bannerbg.png
// module id = 662
// module chunks = 0